import React from "react";
import RegularLayout from "../components/layout/Layout";
import { SEO } from "../components/atoms/Seo";
import HeroSection from "../components/organisms/HeroSection";
import ApplySection from "../components/organisms/ApplySection";
import WhyVellis from "../components/organisms/WhyVellisSection";
import WHY_PARTNERS_CONTENT from "../constants/whyPartnersContent";
import WhoWeServeSection from "../components/organisms/WhoWeServeSection";
import PARTNERS_CONTENT from "../constants/partnersContent";
import { HStack, VStack, Text } from "@chakra-ui/react";
import ContactInfo from "../components/molecules/ContactInfo";
import PartnersApplyForm from "../components/molecules/PartnersApplyForm";

const PARTNERS_CONTENT_2 = [
  {
    icon: {
      node: {
        sourceUrl:
          "https://cms.vellisfinancial.eu/wp-content/uploads/2025/04/secure-payment-fill.svg",
      },
    },
    whoWeServeItemTitle: "Attractive Commission Structure",
    whoWeServeItemDescription:
      "Competitive, performance-based payouts for each qualified referral.",
  },
  {
    icon: {
      node: {
        sourceUrl:
          "https://cms.vellisfinancial.eu/wp-content/uploads/2025/04/bank-card-fill.svg",
      },
    },
    whoWeServeItemTitle: "Reliable Monthly Payments",
    whoWeServeItemDescription: "Regular payments in EUR or USD.",
  },
  {
    icon: {
      node: {
        sourceUrl:
          "https://cms.vellisfinancial.eu/wp-content/uploads/2025/04/user-heart-fill.svg",
      },
    },
    whoWeServeItemTitle: "Dedicated Account Manager",
    whoWeServeItemDescription:
      "Work directly with our experienced partnerships team.",
  },
  {
    icon: {
      node: {
        sourceUrl:
          "https://cms.vellisfinancial.eu/wp-content/uploads/2025/04/truck-fill.svg",
      },
    },
    whoWeServeItemTitle: "Transparent Tracking",
    whoWeServeItemDescription:
      "Access a personalized data to monitor your performance.",
  },
  {
    icon: {
      node: {
        sourceUrl:
          "https://cms.vellisfinancial.eu/wp-content/uploads/2025/04/customer-service-2-fill.svg",
      },
    },
    whoWeServeItemTitle: "Marketing Support",
    whoWeServeItemDescription:
      "Professional marketing assets and dedicated onboarding assistance by an affiliate manager.",
  },

  {
    icon: {
      node: {
        sourceUrl:
          "https://cms.vellisfinancial.eu/wp-content/uploads/2025/04/group-3-fill.svg",
      },
    },
    whoWeServeItemTitle: "Referral Longevity",
    whoWeServeItemDescription:
      "Earn on long-term client value, not just one-off leads.",
  },
  {
    icon: {
      node: {
        sourceUrl:
          "https://cms.vellisfinancial.eu/wp-content/uploads/2025/04/bard-fill.svg",
      },
    },
    whoWeServeItemTitle: "Established Reputation",
    whoWeServeItemDescription:
      "Vellis Financials is a trusted and fully compliant financial services provider supporting businesses with reliable, modern payment solutions.",
  },
];

const IndexPage: React.FC = () => {
  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "Partners", link: "/partners" },
  ];
  return (
    <RegularLayout maxWidth="100%" crumbs={breadcrumbs}>
      <>
        <HeroSection
          heightSize="338px"
          title="Partner with Financial Affiliate Program"
          description="Join our Financial Affiliate Program and grow with Vellis, a trusted global payment service provider"
        />

        <WhoWeServeSection
          whoWeServeMainTitle="Vellis Offers the Best Financial Affiliate Programs​"
          whoWeServeMainDescription="Vellis delivers tailored digital payment solutions. Our financial affiliate programs are built for entrepreneurs, small business owners, and organizations across sectors like e-commerce, healthcare, high-risk, and cross-border industries."
          whoWeServeItems={PARTNERS_CONTENT_2}
        />

        <WhyVellis
          title="Who Should Apply?"
          description="We collaborate with individuals and teams that have strong networks in:"
          content={WHY_PARTNERS_CONTENT}
        />

        <ApplySection content={PARTNERS_CONTENT} />

        <VStack
          maxW="1280px"
          mx="auto"
          mt={20}
          gap={0}
          px={{ base: 4, "2xl": 0 }}
          alignItems="flex-start"
        >
          <Text
            w="100%"
            textAlign="start"
            pb={5}
            lineHeight="100%"
            className="light-text"
            fontSize="48px"
            as="h2"
          >
            Apply to Join
          </Text>
          <Text color="#6A7471" fontSize="16px" className="regular-text" pb={5}>
            Fill out the application below to start your partnership journey.
          </Text>
          <HStack
            flexDirection={{ base: "column", md: "row" }}
            gap={{ base: 6, lg: 10 }}
            w="100%"
            alignItems="flex-start"
          >
            <PartnersApplyForm
              isRequired
              buttonName="Submit Application"
              isContactForm
            />
            <ContactInfo email="info@vellis.financial" />
          </HStack>
        </VStack>
      </>
    </RegularLayout>
  );
};

export const Head = () => (
  <SEO
    title="Financial Affiliate Programs - Partner With Us"
    description="Vellis financial affiliate programs offer competitive commissions, monthly payouts, and expert support for professionals in global financial sectors"
  />
);

export default IndexPage;
